<div class="wrapper">
  <app-topbar></app-topbar>
  <app-navbar *ngIf="!isMobileSidebarVisible"></app-navbar>
  <app-sidenav *ngIf="isMobileSidebarVisible"></app-sidenav>

  <!-- Nội dung thực tế (router-outlet) sẽ được chèn từ MainLayout -->
  <ng-content></ng-content>
</div>